import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { LogErrors } from './../../../utilities/LogErrors'
import { useLanguage } from './../../../utilities/LanguageContext'
import { SaveCenterToShow, SaveRoleToShow } from './../../../utilities/BL/Navigation'

import { Loading } from './../../Common/Loading'
import { CreditsBottom } from './../../Common/Credits/CreditsBottom'
import { Logout as BLLogout } from './../../../utilities/BL/Sessions'

import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'


const Modal = ({ session, centersData, setCenterSelected, setRoleSelected }) => {
    const { translate } = useLanguage()
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()
    
    const [options, setOptions] = useState(null)
    //const [loading, setLoading] = useState(true)
    const [isCenterSelected, setIsCenterSelected] = useState(false)

    const [isLoading, setIsLoading] = useState(true)


    const Logout = async () => {
        try {
            const response = await BLLogout()

            if (response.success) {
                if (response.data === null) {
                    navigate("/")
                } else {
                    showMessage({
                        type: MESSAGE_TYPE.BAD,
                        text: response.message
                    })
                    //console.log(response.message)
                }
            } else {
                //Mostrar mensaje de que no se pudo cerrar la sesión correctamente. Intenta nuevamente o más tarde.
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: response.message
                })
                //console.log(response.message)
            }
        } catch (error) {
            await LogErrors('Logout - Header', error)
        }
    }

    const DeleteCenter = async () => {
        try {
            // 1) Limpia persistencia
            await SaveCenterToShow(session, null) // o BL/Storage que uses
            await SaveRoleToShow(session, null)

            // 2) Limpia estado en el padre (proviene por props)
            setCenterSelected(null)
            setRoleSelected(null)

            // 3) Limpia estado local del modal (volver a lista de centros)
            setIsCenterSelected(false)

            // (Opcional) feedback
            // showMessage({ type: MESSAGE_TYPE.INFO, text: 'Selecciona un centro nuevamente.' })
        } catch (error) {
            await LogErrors('DeleteCenter - Modal', error)
        }
    }


    useEffect(() => {
        const LoadPage = async () => {
            try {
                let tmpOptions = []
                const rolesNames = {
                    4: 'Líder de proyecto',
                    3: 'Administrador',
                    2: 'Instructor',
                    1: 'Ztudiante'
                }

                if (centersData?.length > 0) {
                    if (!isCenterSelected) {
                        tmpOptions = centersData.map(center => ({
                            id: center.id,
                            name: center.name
                        }))
                    } else {
                        const selectedCenter = centersData.find(center => center.id === isCenterSelected)
                        tmpOptions = selectedCenter?.roles?.map(role => ({
                            id: role.id,
                            name: role.name || rolesNames[role.id] || 'Ztudiante' // Si no está en el mapeo, se asigna 'Est'
                        })) || []
                    }
                }

                setOptions(tmpOptions)
            } catch (error) {
                await LogErrors('LoadPage Modal', error)
            } finally {
                //setLoading(false)
                setIsLoading(false)
            }
        }

        LoadPage()
    }, [isCenterSelected, centersData])

    // Maneja la selección del centro y lo guarda en sessionStorage
    // const handleSelectCenter = async (centerId) => {
    //     try {
    //         await SaveCenterToShow(session, centerId)
    //         // al cambiar de centro, forzamos perfil indefinido
    //         await SaveRoleToShow(session, null)

    //         setRoleSelected(null)      // limpia en el padre
    //         setCenterSelected(centerId)
    //         setIsCenterSelected(centerId)
    //     } catch (error) {
    //         await LogErrors('handleSelectCenter - Modal', error)
    //     }
    // }

    // Maneja la selección del centro y lo guarda en sessionStorage
    const handleSelectCenter = async (center) => {
        try {
            await SaveCenterToShow(session, center)
            // al cambiar de centro, forzamos perfil indefinido
            await SaveRoleToShow(session, null)

            setRoleSelected(null)      // limpia en el padre
            setCenterSelected(center.id)
            setIsCenterSelected(center.id)
        } catch (error) {
            await LogErrors('handleSelectCenter - Modal', error)
        }
    }

    // Maneja la selección del perfil y lo guarda en sessionStorage
    const handleSelectRole = async (role) => {
        try {
            await SaveRoleToShow(session, role)
            setRoleSelected(role.id)
        } catch (error) {
            await LogErrors('handleSelectRole - Modal', error)
        }
    }

    useEffect(() => {
        document.getElementById("root").classList.add("Background--Ztudia")
        
        return () => {
            document.getElementById("root").classList.remove("Background--Ztudia")
        }
    }, [])
    

    
    
    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                {options ? (
                    <>
                        <aside className="Modal Fonts--PlusJakartaSans">
                            <div className={`${isCenterSelected ? 'Modal__Menu--Double' : 'Modal__Menu--One'}`}>
                                {/* Mostrar hasta que haya seleccionad un centro */}
                                {isCenterSelected && (
                                    <button className="Btn__Ztudia--Link Modal__Menu__Button Modal__Menu__Button--IconBig" type="button" onClick={() => { if (isCenterSelected) DeleteCenter(); }} disabled={!isCenterSelected}><i className="bi bi-arrow-left"></i></button>
                                )}

                                <button className="Btn__Ztudia--DangerOutline Modal__Menu__Button" type="button" onClick={() => Logout()}><i className="bi bi-box-arrow-right"></i></button>
                            </div>

                            <p className="Modal__Question">
                                {translate(isCenterSelected ? 'labels.dashboard.role.deselected' : 'labels.dashboard.center.deselected')}
                            </p>

                            {options.length === 0 ? (
                                <p>No tienes centros o perfiles asignados.</p>
                            ) : (
                                options.map((option, index) => (
                                    <button
                                        key={index}
                                        type='button'
                                        className="Modal__Options"
                                        onClick={() => {
                                            if (!isCenterSelected) {
                                                handleSelectCenter(option)
                                            } else {
                                                handleSelectRole(option)
                                            }
                                        }}
                                    >
                                        {option.name}
                                    </button>
                                ))
                            )}
                        </aside>

                        <CreditsBottom />
                    </>
                ) : (
                    isCenterSelected ? (
                        <p className='Fonts--PlusJakartaSans'>Actualmente no tienes perfiles asignados. Contacta con el líder de proyecto del centro.</p>
                    ) : (
                        <p className='Fonts--PlusJakartaSans'>Actualmente no tienes centros asignados. Contacta con el líder de proyecto del centro.</p>
                    )
                )}
            </>
        )
    )
}

export { Modal };